/// <amd-module name="Dashboards/DashboardView/src/components/complementary/WidgetConfigProxy" />
import * as React from "react";

import { ConfigPanelProps } from "Dashboards/WidgetContracts/Internal/ConfigPanelProps";

import { VssComponent, WrappedComponent } from "VSS/Platform/Layout";

/** Encapsulates delay-loaded Widget Config Experience. */
export class WidgetConfigProxy extends VssComponent<ConfigPanelProps> {
    public render(): JSX.Element | null {
        return (
            <WrappedComponent
                key={"config-panel"}
                wrappedType={"ConfigPanel"}
                dependencies={["ms.vss-dashboards.dashboards-config-host"]}
                wrappedProps={this.props}
            />
        );
    }
}
